export const genderOptions = [
    { value: 'female', label: 'Female' },
    { value: 'male', label: 'Male' },
    { value: 'other', label: 'Other' }
];

// Marital options:

export const maritalOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' }
];

// Language options:
export const languageOptions =
    [
        { label: 'English', value: 'english' },
        { label: 'Hindi', value: 'hindi' },
        { label: 'Tamil', value: 'tamil' },
        { label: 'Telugu', value: 'telugu' }
    ]

// levelOptions:
export const fluencyOptions = [
    { label: 'Basic', value: 'basic' },
    { label: 'Conversational', value: 'conversational' },
    { label: 'Fluent', value: 'fluent' },
    { label: 'Native', value: 'native' }
];

export const gradeOptions = [
    { value: "CGPA", label: "CGPA" },
    { value: "Percentage", label: "Percentage" },
];

export const mode = [
    { value: "full-time", label: "Full-time" },
    { value: "part-time", label: "Part-time" },
    { value: "online", label: "Online" },
    { value: "hybrid", label: "Hybrid" }
];



export const workMode = [
    { label: "Onsite", value: "onsite" },
    { label: "Remote", value: "remote" },
    { label: "Hybrid", value: "hybrid" }
];


export const jobType = [
    { label: "Contract", value: "contract" },
    { label: "Full Time", value: "fulltime" },
    { label: "Full Time / Lateral", value: "fulltime/lateral" },
    { label: "Internal Strategic Roles", value: "internal strategic roles" },
    { label: "Part Time", value: "part time" },
    { label: "Sub Contract", value: "sub contract" },
    { label: "Temporary and Third Party", value: "temporary and third party" },
];


export const noticePeriod = [
    { label: "Immediate", value: "immediate joiner" },
    { label: "7 Days", value: "7 days" },
    { label: "15 Days", value: "15 days" },
    { label: "30 Days", value: "30 days" },
    { label: "45 Days", value: "45 days" },
    { label: "60 Days", value: "60 days" },
    { label: "90 Days", value: "90 days" },
    { label: "Currently serving notice period", value: "currently serving notice period" },
];


export const currencyOptions = [
    { label: "INR (₹)", value: "inr" },
    { label: "USD ($)", value: "usd" },
    { label: "EUR (€)", value: "eur" },
    { label: "GBP (£)", value: "gbp" },
    { label: "AUD (A$)", value: "aud" },
    { label: "CAD (C$)", value: "cad" },
    { label: "SGD (S$)", value: "sgd" },
    { label: "JPY (¥)", value: "jpy" },
    { label: "AED (د.إ)", value: "aed" },
    { label: "SAR (﷼)", value: "sar" }
];


export const priorityOptions = [
    { label: "Low", value: "low" },
    { label: "Medium", value: "medium" },
    { label: "High", value: "high" },
    { label: "Critical", value: "critical" }
];

export const Status = [
    { label: "Active", value: "active" },
    { label: "Closed", value: "closed" },
    { label: "Filled", value: "filled" },
    { label: "Hold-by-client", value: "hold-by-client" },
    { label: "on-hold", value: "on-hold" }
]


export const industryTypes = [
    { "value": "it_software", "label": "IT / Software" },
    { "value": "mechanical_engineering", "label": "Mechanical Engineering" },
    { "value": "electrical_engineering", "label": "Electrical Engineering" },
    { "value": "civil_engineering", "label": "Civil Engineering" },
    { "value": "banking_finance", "label": "Banking / Finance" },
    { "value": "education", "label": "Education / Teaching" },
    { "value": "government", "label": "Government" },
    { "value": "healthcare", "label": "Healthcare / Medical" },
    { "value": "hospitality", "label": "Hospitality / Travel / Tourism" },
    { "value": "retail", "label": "Retail / FMCG" },
    { "value": "marketing_advertising", "label": "Marketing / Advertising / PR" },
    { "value": "sales", "label": "Sales / Business Development" },
    { "value": "hr", "label": "Human Resources / Recruitment" },
    { "value": "research", "label": "Research / Analytics / Data Science" },
    { "value": "legal", "label": "Legal / Compliance" },
    { "value": "administration", "label": "Administration / Office Support" },
    { "value": "logistics_transport", "label": "Logistics / Supply Chain / Transport" },
    { "value": "media_entertainment", "label": "Media / Entertainment / Content" },
    { "value": "telecom", "label": "Telecom / Networking" },
    { "value": "consulting", "label": "Consulting / Advisory" },
    { "value": "freelance_gig", "label": "Freelance / Gig Work" }
]

